import React from "react";
import bannerVideo from "../assets/images/actuall.mp4";


function HomeBanner() {
  return (
    <section id="home_banner-wrapper">
      <div className="banner-img">
        <div className="video-container">
          <video
            autoPlay
            muted
            loop
            playsInline
          >
            <source src={bannerVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

 
    </section>
  );
}

export default HomeBanner;
